<template>
  <div>
    <q-input
      class="q-mt-xs"
      style="min-width: 300px"
      @click.stop
      @keyup.stop
      dense
      filled
      type="text"
      label="请输入"
      :value="value"
      @input="handleInput"
      :error="!!errorMsg"
      :error-message="errorMsg"
    />
  </div>
</template>

<script>
import QuestionChoiceMixin from "./question-choice.mixin";
export default {
  mixins: [QuestionChoiceMixin],

  data() {
    return {
      errorMsg: "",
    };
  },

  watch: {
    checked(ckd) {
      if (ckd) {
        setTimeout(() => {
          this.$nextTick(() => this.handleInput(this.value || ""));
        }, 0);
      } else {
        this.errorMsg = "";
      }
    },
  },

  computed: {
    errorTextDict() {
      const { errorMsg } = this;
      return {
        errorMsg,
      };
    },
  },

  methods: {
    handleInput(v) {
      if (!v) {
        this.errorMsg = "请输入";
      } else this.errorMsg = "";

      if (!this.checked) {
        this.errorMsg = "当前选项未选中，输入无效";
      }
      this.$emit("change", v);
    },
  },
};
</script>
